module.exports = __webpack_public_path__ + "static/media/lock.8a16ce20.svg";